import { Avatar, Box, Button, Paper, Typography } from "@mui/material";
import { ReviewCardProps } from "components/Reviews/ReviewCard";
import React from "react";

const EvaluationCard = ({ review,onEvaluate }: ReviewCardProps) => {
    const handleEvaluate = () => {
        onEvaluate(review.id)
    }
  return (
    <Box sx={{ mt: 2 }}>
      <Paper elevation={3} sx={{ backgroundColor: "#F6F7FA" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "14px",
          }}
        >
          <Avatar
            src={review?.user?.profile_image}
            alt={`${review?.user?.first_name} ${review?.user?.last_name}`}
            sx={{ width: 80, height: 80 }}
          />
          <Typography variant="h6" fontSize="18px" fontWeight={800} mt={1} mb={1} color="#146ED2">
            {`${review?.user?.first_name} ${review?.user?.last_name}`}
          </Typography>
          <Button variant="contained" fullWidth onClick={handleEvaluate}>
            Evaluate
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default EvaluationCard;
